module.exports = __webpack_public_path__ + "img/xlsx.a88aab52.png";